import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {RefundRequest} from "../refund-request.model";

export class RefundRequestDgSearchResults extends GenericDgSearchResults {
  public results: RefundRequest[];

  constructor(total: number, results: RefundRequest[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
